import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Consumer_Hierarchy_Search_Fields: {[id:string]: ISearchProviderField } = {

    WB_CUSTH_ID:                {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Customer Hierarchy Type', columnResourceName: 'colHierarchyType', alignment: HorizAlignment.Center}, domainOptions: {}},
    WB_CUST_HIER_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Hierarchy Id', columnResourceName: 'colHierarchyID', alignment: HorizAlignment.Right}, domainOptions: {}},
    WB_CUST_HIER_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Hierarchy Name', columnResourceName: 'colHierarchyName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    CUSTOMER_HIERARCHY_TYPE:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Hierarchy Type', columnResourceName: 'colHierarchyType', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 50}},
    HIERARCHY_USAGE:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Hierarchy Usage', columnResourceName: 'colHierarchyUsage', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 50}},
    SOURCE_ID:                  {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source ID', columnResourceName: 'colSourceId', alignment: HorizAlignment.Right}, domainOptions: {}},
    SALESORG:                   {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Sales Org', columnResourceName: 'colSalesOrg', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    DISTRIBCHANNEL:             {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Distribution Channel', columnResourceName: 'colDistributionChannel', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 50}},
    DIVISION:                   {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Division', columnResourceName: 'colDivision', alignment: HorizAlignment.Right}, domainOptions: {}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

var CustomerHierarchySearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_CUSTH_ID',
        id_ui: 'WB_CUST_HIER_ID',
        name:  'WB_CUST_HIER_NAME'},

    searchProviderFields: vUI_Consumer_Hierarchy_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Customer_Hierarchy_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var CustomerHierarchySearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "CustomerHierarchySearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'WB_CUST_HIER_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'WB_CUST_HIER_NAME', renderOptions: { }},
    ],  // ISearchFields
    profileDisplayFields: [
        'WB_CUST_HIER_ID','WB_CUST_HIER_NAME','CUSTOMER_HIERARCHY_TYPE','HIERARCHY_USAGE','SOURCE_ID','SALESORG','DISTRIBCHANNEL',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: CustomerHierarchySearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var CustomerHierarchySearch: ISearch = {
    searchName: "Find CustomerHierarchy",
    renderOptions: { ui5ResourceId: "CustomerHierarchySearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [CustomerHierarchySearchProfileByName]
}

PAEnvironment.registerBusinessObjectSearch("CustomerHierarchyBO", "CustomerHierarchy", CustomerHierarchySearch, "Customer Hierarchy Search")

export {CustomerHierarchySearch}
